// globals: jQuery

import cardConnectIframeDialog from './cardConnectFrameDialog';

var cardConnectFrameDialogService;
var cardConnectFrameDialogServiceBillingInfo;
var cardConnectFrameDialogServiceRefund;

(function($) {

    var CardConnectFrameDialogRect = {
        width: '640',
        height: '550'
    };

    cardConnectFrameDialogService = function() {

    };

    cardConnectFrameDialogService.prototype.containerId = 'cardConnectFrameDialogFormContainer';

    /**
     * @returns {*|jQuery|HTMLElement}
     */
    cardConnectFrameDialogService.prototype.getContainer = function() {
        return $('#' + this.containerId);
    };

    /**
     * @param form
     * @param data
     */
    cardConnectFrameDialogService.prototype.onSuccess = function() {

    };

    cardConnectFrameDialogService.prototype.onEmvSuccess = function() {

    };

    /**
     * @param callback
     * @param params
     */
    cardConnectFrameDialogService.prototype.init = function(callback, params) {

        this.isSuccess = false;
        $('<div id="' + this.containerId + '"></div>').appendTo('body');
        var $cardConnectFrameDialogFormContainer = this.getContainer();
        var context = this;
        var cardConnectIframeDialogOptions = params.cardConnectIframeDialogOptions ? params.cardConnectIframeDialogOptions : null;
        var options = {
            onDialogOpened: function() {
                cardConnectIframeDialog.onSuccess = function(form, data) {
                    context.onSuccess(form, data);
                    callback(form, data);
                    var $formDialog = $('#cardConnectFrameFormDialog');
                    var $dialog = $formDialog.closest('.ca-dialog');
                    $dialog.prev('.ui-widget-overlay').remove();
                    $dialog.remove();
                    $formDialog.remove();
                };
                cardConnectIframeDialog.onEmvSuccess = function(data) {
                    context.onEmvSuccess(data);
                    var $dialog = $("#cardConnectFrameFormDialog").closest(".ca-dialog");
                    $dialog.prev(".ui-widget-overlay").remove();
                    $dialog.remove();
                    $("#cardConnectFrameFormDialog").remove();
                };
                cardConnectIframeDialog.init(cardConnectIframeDialogOptions);
            }
        };
        if (params) {
            if (params.dialogOptions) {
                params.dialogOptions.width = CardConnectFrameDialogRect.width;
                params.dialogOptions.height = CardConnectFrameDialogRect.height;
            }
            options = $.extend(options, params);
        }
        $cardConnectFrameDialogFormContainer.cardConnectFrameDialogForm(options);
    };

    /**
     * @param callback
     * @param params
     */
    cardConnectFrameDialogService.prototype.open = function(callback, params) {
        this.init(callback, params);
        this.getContainer().cardConnectFrameDialogForm('openDialog');
    };

    cardConnectFrameDialogServiceBillingInfo = new cardConnectFrameDialogService();

    cardConnectFrameDialogServiceBillingInfo.onSuccess = function (form, data) {
        jQuery('#cc_date-month').val(data.expiration_month);
        jQuery('#cc_date-year').val(data.expiration_year);
    };

    cardConnectFrameDialogServiceBillingInfo.onEmvSuccess = function(data) {
        var request = data.request;
        var dataPrepared = {
            cc_merchant_unique_id: data.uniqueId.toString(),
            expiration_month: request.i4go_expirationmonth,
            expiration_year: request.i4go_expirationyear,
            cardConnect_expiry: request.i4go_expirationyear + request.i4go_expirationmonth
        };

        var $form = jQuery('#paymentMethodEditForm');

        cardConnectIframeDialog.setCardConnectParamsToForm($form, dataPrepared, function() {

        });
        cardConnectFrameDialogServiceBillingInfo.onSuccess(null, dataPrepared);
    };

    $.widget('ca.cardConnectFrameDialogForm', $.ca.caDialogForm, {
        options: {
            dialog: null,
            form: null,
            formParams: {},
            formUrl: '/card-connect/get-frame-form',
            dialogOptions: {
                title: '<b>Enter Credit/Debit Card to store on file</b>',
                width: CardConnectFrameDialogRect.width,
                height: CardConnectFrameDialogRect.height,
                caProUI: true,
                staticForm: false,
            },
        },
    });

    cardConnectFrameDialogServiceRefund = new cardConnectFrameDialogService();
    cardConnectFrameDialogServiceRefund.onSuccess = function(form, data) {
        var associationKeys = {
            'cc_number' : 'cc_number',
            'cc_merchant_unique_id' : 'cc_merchant_unique_id',
            'cc_expirationyear' : 'expiration_year',
            'cc_expirationmonth' : 'expiration_month'
        };

        jQuery.each(associationKeys, function(key, item) {
            if (!jQuery('.credit-card-form input[name="' + key + '"]').length) {
                jQuery('.credit-card-form').append('<input type="hidden" name="' + key + '" value="' + data[item] + '">');
            }
            jQuery('.credit-card-form input[name="' + key + '"]').attr('value', data[item]);
        });
    };


})(jQuery);

export {
    cardConnectFrameDialogService,
    cardConnectFrameDialogServiceBillingInfo,
    cardConnectFrameDialogServiceRefund
}
